import { MixpanelEvents } from "@/constants/mixpanel-events";
import { aiChatModalOpenAtom, chatScrollToMessageIdAtom } from "@/stores/chat.store";
import { trackMixpanelEvent } from "@/utils/mixpanel";
import { useSetAtom } from "jotai";
import { useCallback } from "react";

/**
 * Reopens the current chat (no reset) scrolled to a specific message — used by
 * the My Plan "just added" badge to show the "Added to your plan" card that
 * created a meal. If the message is no longer in the transcript the page just
 * opens at the bottom as usual.
 */
export const useOpenChatAtMessage = () => {
  const setScrollToMessageId = useSetAtom(chatScrollToMessageIdAtom);
  const openAiChatModal = useSetAtom(aiChatModalOpenAtom);

  return useCallback(
    (messageId: string) => {
      trackMixpanelEvent(MixpanelEvents.AI_CHAT_OPENED);
      setScrollToMessageId(messageId);
      openAiChatModal(true);
    },
    [setScrollToMessageId, openAiChatModal],
  );
};
